import React, { useEffect, useState } from "react";
import { useToaster } from "../../context/ToasterContext";
import TextInputComponent from "../../components/textinput";
import ButtonComponent from "../../components/button";
import { formatAmountInLocale } from "../../utils/global";

const PaymentNameScreen = ({ order_type, loading, shopDetails, currentOrderData, splitAmountToBePaid, getOrderStatusResult, name, setName, setStep, createPaymentIntentApiCall, mountPaymentElements, pageName }) => {
  const { toaster } = useToaster();

  const nextStep = (e) => {
    e.preventDefault();

    if(name === '' || name === null){
      toaster.error("Please enter your name!");
    }
    else{
      localStorage.setItem("username", name);

      if(order_type === 'variable_price' || order_type === 'variable_self'){
        setStep(1);
      }
      else{
        setStep(2);

        if(pageName === 'stripe-payment' || pageName === 'adyen-payment' || pageName === 'airwallex-payment' || pageName === 'tyro-payment' || pageName === 'nets-payment'){
          createPaymentIntentApiCall(currentOrderData);
        }
        else if(pageName === 'square-payment'){
          mountPaymentElements();
        }
      }
    }
  };

  return (
    <>
      <div>
        {order_type !== 'variable_price' && order_type !== 'variable_self' &&
          <div className="text-center mb-3">
            <p className="text-color-amount-label">Amount left to be paid</p>
            {!loading && <h4 className="text-color-amount-heading">{shopDetails.currency_with_symbol}{formatAmountInLocale(shopDetails.user_currency,splitAmountToBePaid)}</h4>}
          </div>
        }
        {(order_type === 'variable_price' || order_type === 'variable_self') &&
          <div className="text-center mb-3">
            <p className="text-color-amount-label">Amount left to be paid</p>
            {!loading && <h4 className="text-color-amount-heading">{shopDetails.currency_with_symbol}{formatAmountInLocale(shopDetails.user_currency,getOrderStatusResult.amount_left)}</h4>}
          </div>
        }
        {order_type === 'variable_price' &&
          <div className="text-center mb-3">
            <p className="note">On the next screen, you will have to enter the amount you wish to contribute and proceed to pay</p>
          </div>
        }
        {order_type === 'variable_self' &&
          <div className="text-center mb-3">
            <p className="note">On the next screen, you will have to enter the amount you wish to stack and proceed to pay</p>
          </div>
        }

        <form id="name-form" className="whiteCard mt-4" onSubmit={nextStep}>
          <div className="input-wrapper mb-0">
            <TextInputComponent
              label="Enter your name"
              id="name"
              value={name}
              type="text"
              onChange={(e) => {
                setName(e.target.value);
              }}
              size="lg"
              placeholder="E.g.: John Doe"
              disabled={loading}
            />

            <ButtonComponent
              type="submit"
              id="next_btn"
              className="btn btn-primary btn-pool-shadow btn-pool-full"
              label="Next"
              size="md"
              variant="primary"
            ></ButtonComponent>
          </div>
        </form>
      </div>
    </>
  );
};

export default PaymentNameScreen;
